// MpfForm.props.ts
import { MpfInputDateProps } from '../MpfInputDate/MpfInputDate.props';
import { MpfInputTextProps } from '../MpfInputText/MpfInputText.props';
import { MpfRadiosProps } from '../MpfRadios/MpfRadios.props';
import { MpfCheckboxesProps } from '../MpfCheckboxes/MpfCheckboxes.props';
import { HeadingLevel, HeadingLevelSize } from '../MpfInput/MpfInputBaseProps';
import { MpfInputTextareaProps } from '../MpfInputTextarea/MpfInputTextarea.props';
import { MpfAttachmentsProps } from '../MpfAttachments/MpfAttachments.props';

export const MpfInputTextTypes = ['text', 'email', 'phone', 'postcode'] as const;
export type MpfInputTextType = (typeof MpfInputTextTypes)[number];

export type MpfFormFieldType =
  | MpfInputTextType
  | 'attachments'
  | 'textarea'
  | 'radios'
  | 'checkboxes'
  | 'date'
  | 'dateOfBirth';

export type FormFieldValue =
  | string // text, email, phone, postcode, textarea, date, radios
  | (string | number | null)[] // checkboxes (multi select)
  | null
  | File[];

// Input types that basically use plaintext but might have validation for its value
export function isMpfInputTextType(type: MpfFormFieldType): type is MpfInputTextType {
  return (MpfInputTextTypes as readonly string[]).includes(type);
}

//
export type MpfFormFieldConfig =
  | (MpfFormDateProps & { type: 'dateOfBirth' | 'date' })
  | (MpfRadiosProps & { type: 'radios' })
  | (MpfAttachmentsProps & { type: 'attachments' })
  | (MpfCheckboxesProps & { type: 'checkboxes' })
  | (MpfInputTextareaProps & { type: 'textarea' })
  | (MpfInputTextProps & {
      type: 'text' | 'email' | 'phone' | 'postcode';
      initialValue?: FormFieldValue;
    });

export interface MpfFormDateProps extends Omit<MpfInputDateProps, 'modelValue'> {
  modelValue?: string;
  type: 'dateOfBirth' | 'date';
}
export type FormError = { name: string; errors: string[] | string };

export interface MpfFormProps {
  headingLevel?: HeadingLevel;
  headingLevelSize?: HeadingLevelSize;
  formTitle?: string;
  hint?: string;
  fields: MpfFormFieldConfig[];
  mode?: 'edit' | 'create' | 'view';
  formErrors?: FormError[];
  submitLabel?: string;
  errorSummaryByLine?: string;
  errorSummaryTitle?: string;
  showErrors?: boolean;
}

export const mpfFormDefaults = {
  submitLabel: 'Submit',
  mode: 'edit',
  headingLevel: 2 as HeadingLevel,
  headingLevelSize: 'l' as HeadingLevelSize,
  errorSummaryByLine: 'Please fix the following errors:',
  errorSummaryTitle: 'There is a problem',
} satisfies Partial<MpfFormProps>;

export interface ResponseFormErrors {
  name: string;
  errors: string[] | string;
}
